import React, { useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getSupplierThunk } from 'redux/Reducers/Concierge/supplierSlicer';
import { uploadFileThunk } from 'redux/Reducers/Concierge/uploadFileSlicer';

import "Assets/styles/default/components/Concierge/Components/SupplierInformation.less";

import { Col, Row } from 'antd';
import { ArrowRightOutlined, CheckCircleOutlined } from '@ant-design/icons';

import {
    Form,
    Typography,
    Upload,
    VertButton,
    VertRadio,
    VertSelect,
    VertTypography,
    message,
} from '@vertem-core/vertice-ds';

import CreateSupplierModal from '../Modals/CreateSupplierModal';

import PropTypes from 'prop-types';

import generateUUID from 'Utils/generateUUID';
import { LuArrowRight } from 'react-icons/lu';

const SupplierInformation = ({ ...props }) => {
    const {
        solicitation,
        setSolicitation,
        handleNextStep,
        handlePreviousStep
    } = props;

    const [term, setTerm] = useState();
    const [supplierList, setSupplierList] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [showCreateSupplierModal, setShowCreateSupplierModal] = useState(false);
    const [supplierSearchDebounce, setSupplierSearchDebounce] = useState(null);

    const [form] = Form.useForm();

    const dispatch = useDispatch();

    const {
        dataSupplier,
        loadingSupplier
    } = useSelector(
        (state) => state.Supplier
    );

    const {
        dataUploadFile,
        loadingUploadFile,
        errorUploadFile
    } = useSelector(
        (state) => state.UploadFile
    );

    useMemo(() => {
        if (!dataSupplier) return setSupplierList([]);
        setSupplierList(dataSupplier.map(supplier => {
            return {
                value: supplier.id,
                label: supplier.label,
                name: supplier.name,
            }
        })
        );
    }, [dataSupplier]);

    const searchSupplier = (term) => {
        if (supplierSearchDebounce) clearTimeout(supplierSearchDebounce);

        if (!term) {
            dispatch(getSupplierThunk({ includeNotCompleted: false, includeSupplierId: solicitation.supplierId }));
            return;
        }

        setTerm(term);

        const timeoutId = setTimeout(() => {
            dispatch(getSupplierThunk({ term, includeNotCompleted: false, includeSupplierId: solicitation.supplierId }));
        }, 450);

        setSupplierSearchDebounce(timeoutId);
    }

    const handleHasFavoriteSupplier = (hasFavoriteSupplier) => {
        setSolicitation((solicitation) => ({
            ...solicitation,
            haveFavoriteSupplier: hasFavoriteSupplier,
            supplierId: hasFavoriteSupplier ? solicitation.supplierId : null,
            quoteFileName: null,
            quoteFileUrl: null,
        }))
    }

    const handleSelectedSupplier = (_, supplier) => {
        setSolicitation((solicitation) => ({
            ...solicitation,
            supplierId: supplier.value,
            supplierName: supplier.label,
        }));

        setSelectedSupplier(supplier);
    }

    const retrieveCreatedSupplier = (supplierId) => {
        dispatch(getSupplierThunk({ includeNotCompleted: false, includeSupplierId: supplierId })).then((res) => {
            const { payload } = res;

            const createdSupplier = payload.find(supplier => supplier.id === supplierId);

            setSolicitation({
                ...solicitation,
                supplierId,
                supplierName: createdSupplier.label,
            });

            setSelectedSupplier({
                label: createdSupplier.label,
                value: supplierId,
            });
        })
    }

    const renderNotFoundOptions = () => {
        return (
            solicitation.isConcierge && term ? (
                <p className="concierge-create-supplier-option" onClick={() => setShowCreateSupplierModal(true)}>
                    Criar <span>"{term}"</span> como fornecedor
                    <ArrowRightOutlined className="concierge-create-supplier-icon" />
                </p>
            ) : (
                <VertTypography.Text>
                    Sem resultados.
                </VertTypography.Text>
            )
        )
    }

    const continueStep = () => {
        handleNextStep(solicitation);
    }

    const disableContinueButton = () => {
        if (!solicitation.isConcierge) {
            if (!solicitation.supplierId || !solicitation.quoteFileUrl) return true;
        } else {
            if (solicitation.haveFavoriteSupplier === null) return true;
            if (solicitation.haveFavoriteSupplier && !solicitation.supplierId) return true;
        }

        return false;
    }

    const uploadQuote = (e) => {
        if (e.fileList.length === 0 || !e.file) return;

        setFileList(e.fileList);

        setSolicitation({
            ...solicitation,
            fileList: e.fileList,
            quoteFileName: e.file.name,
        });

        const formData = new FormData();
        formData.append('file', e.file);

        dispatch(uploadFileThunk(formData));
    };

    const retrieveFileList = () => {
        if (!solicitation.quoteFileUrl) return;

        const loadedFile = {
            uid: generateUUID(),
            name: solicitation.quoteFileName,
            status: 'done',
            url: solicitation.quoteFileUrl,
        };

        setFileList([loadedFile]);

        return [loadedFile];
    }

    useEffect(() => {
        if (dataUploadFile) {
            setSolicitation((solicitation) => ({
                ...solicitation,
                quoteFileUrl: dataUploadFile
            }))
        }
    }, [dataUploadFile]);

    useEffect(() => {
        if (errorUploadFile) {
            message.error("Houve um erro ao anexar o arquivo!");
        }
    }, [errorUploadFile]);

    useEffect(() => {
        if (!solicitation.supplierId) return;

        dispatch(getSupplierThunk({ includeNotCompleted: false, includeSupplierId: solicitation.supplierId }))
            .unwrap()
            .then((res) => {
                if (Array.isArray(res)) {
                    const selectedSupplier = res?.find(supplier => supplier.id === solicitation.supplierId);

                    setSelectedSupplier({
                        label: selectedSupplier.label,
                        value: solicitation.supplierId,
                    });
                }
            })
    }, []);

    return (
        <>
            <Form form={form} >
                <div className="container-concierge-information-main">

                    {
                        solicitation.isConcierge &&
                        <>
                            <Typography.Text className='text-subtitle'>
                                Você possui um fornecedor de preferência?
                            </Typography.Text>

                            <Row gutter={[8, 8]} className='radio-group-request-type'>

                                <Col onClick={() => handleHasFavoriteSupplier(true)}>
                                    <div className={`radio-request-type ${solicitation.haveFavoriteSupplier ? 'radio-selected' : ''}`}>
                                        <Form.Item noStyle>
                                            <VertRadio checked={solicitation.haveFavoriteSupplier}>
                                                Sim
                                            </VertRadio>
                                        </Form.Item>
                                    </div>
                                </Col>

                                <Col onClick={() => handleHasFavoriteSupplier(false)}>
                                    <div className={`radio-request-type ${solicitation.haveFavoriteSupplier !== null && !solicitation.haveFavoriteSupplier ? 'radio-selected' : ''}`}>
                                        <Form.Item noStyle>
                                            <VertRadio checked={solicitation.haveFavoriteSupplier !== null && !solicitation.haveFavoriteSupplier}>
                                                Não
                                            </VertRadio>
                                        </Form.Item>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    }

                    {
                        (!solicitation.isConcierge || solicitation.haveFavoriteSupplier) &&
                        <div className='container-client-information-sub'>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <Typography.Text className='text-subtitle'>
                                        Busque ou selecione o fornecedor:
                                    </Typography.Text>
                                </Col>
                                <Col span={24}>
                                    <Form.Item>
                                        <VertSelect
                                            className="supplier-search"
                                            showSearch
                                            items={supplierList}
                                            onFocus={e => searchSupplier(e.target.value)}
                                            onSearch={searchSupplier}
                                            filterOption={(input, option) => {
                                                return (
                                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                );
                                            }}
                                            onSelect={(_, supplier) => handleSelectedSupplier(_, supplier)}
                                            value={selectedSupplier}
                                            loading={loadingSupplier}
                                            placeholder='Razão Social / CNPJ'
                                            notFoundContent={
                                                <>
                                                    {loadingSupplier
                                                        ? <VertTypography.Text>Carregando...</VertTypography.Text>
                                                        : renderNotFoundOptions()
                                                    }
                                                </>
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Typography.Text className='text-subtitle'>
                                {!solicitation.isConcierge ? "Envie o arquivo de cotação:" : "Você possui algum arquivo de cotação? Se sim, envie-o abaixo:"}
                            </Typography.Text>

                            <Row className="concierge-create-supplier-upload-row">
                                <Form.Item
                                    name="fileList"
                                    valuePropName="fileList"
                                    getValueFromEvent={uploadQuote}
                                >
                                    <Upload
                                        className="btn-upload"
                                        maxCount={1}
                                        fileList={fileList}
                                        defaultFileList={retrieveFileList}
                                        listType="text"
                                        type="select"
                                        onRemove={() => {
                                            setFileList([]);
                                            setSolicitation({
                                                ...solicitation,
                                                fileList: [],
                                                quoteFileName: null,
                                                quoteFileUrl: null,
                                            });
                                        }}
                                        beforeUpload={() => {
                                            return false;
                                        }}
                                    >
                                        <VertButton
                                            className='button-upload-file'
                                            type="default"
                                            icon={fileList.length > 0 && <CheckCircleOutlined />}
                                            block
                                            loading={loadingUploadFile}
                                        >
                                            {loadingUploadFile
                                                ? 'inserindo arquivo...'
                                                : 'inserir arquivo'}
                                        </VertButton>
                                    </Upload>
                                </Form.Item>
                            </Row>
                        </div>
                    }
                </div >

                <Row className="btn-group" gutter={[8, 8]} justify={'end'}>
                    <Col className='collum-btn-concierge'>
                        <VertButton
                            className='button-continue button-concierge'
                            type='default'
                            size="default"
                            onClick={() => handlePreviousStep()}
                        >
                            <Typography.Text className='span-button-return'>
                                Voltar
                            </Typography.Text>

                        </VertButton>
                    </Col>
                    <Col className='collum-btn-concierge'>
                        <VertButton
                            htmlType="submit"
                            className='button-continue button-concierge'
                            type='highlight'
                            size="default"
                            disabled={disableContinueButton()}
                            onClick={continueStep}
                        >
                            <Typography.Text className='span-button-continue'>
                                Continuar
                            </Typography.Text>

                            <LuArrowRight />

                        </VertButton>
                    </Col>
                </Row>
            </Form>

            <CreateSupplierModal
                isOpen={showCreateSupplierModal}
                setIsOpen={setShowCreateSupplierModal}
                term={term}
                retrieveCreatedSupplier={retrieveCreatedSupplier}
            />
        </>
    )
}

SupplierInformation.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
};

export default SupplierInformation;
